import { prefix } from './module';

export const SET_FILTERS = prefix('SET_FILTERS');
